export class BloodType{
    constructor(
        public id: number,
        public name: string
    ){}
}